/**
 * @fileoverview Textos da área Equipe e permissões (accessControl.* nas
 * traduções): o nome e a ajuda de cada permissão do catálogo, os perfis, as
 * licenças, os níveis de conversas, a origem de cada linha e o motivo das
 * travadas. A chave da permissão ("tickets.view") vira o caminho da tradução.
 * E o texto das buscas da área, sem acento e minúsculo.
 */

import { i18n } from "../../translate/i18n";
import stripAccents from "../../utils/stripAccents";

const t = (key, options) => i18n.t(`accessControl.${key}`, options);

export const roleLabel = (role) => t(`roles.${role}`);
export const roleHelp = (role) => t(`roleHelp.${role}`);
export const licenseLabel = (license) => t(`licenses.${license || "full"}`);
export const scopeLabel = (scope) => t(`scopes.${scope || "none"}`);
export const groupLabel = (group) => t(`groups.${group}`);
export const permissionTitle = (key) => t(`permissions.${key}.title`);
export const permissionHelp = (key) => t(`permissions.${key}.help`);
export const originLabel = (origin) => t(`origin.${origin}`);
export const lockLabel = (lock, license) => t(`locks.${lock}`, { license: licenseLabel(license) });
export const readOnlyLabel = (reason) => t(`readOnly.${reason}`);

/** "2 concedidas, 1 negada"; sem personalizações, "". */
export const customizationsLabel = ({ granted = 0, denied = 0 }) =>
  [
    granted ? t(granted === 1 ? "people.grantedOne" : "people.grantedMany", { count: granted }) : null,
    denied ? t(denied === 1 ? "people.deniedOne" : "people.deniedMany", { count: denied }) : null,
  ]
    .filter(Boolean)
    .join(", ");

/** O texto como as buscas da área comparam: sem acento e minúsculo. */
export const normalize = (text) => stripAccents(String(text || "")).toLowerCase();

// As datas ficam em utils/formatLocaleDate (também usadas pelo CRM).
export { formatDateTime, formatDate } from "../../utils/formatLocaleDate";
